import React, { useState, useEffect } from "react";
//import { Button, Form, Alert } from "react-bootstrap";
import {connect, useSelector} from 'react-redux';
import Spinner from 'react-bootstrap/Spinner';
import Button from '@material-ui/core/Button';
import FormGroup from '@material-ui/core/FormGroup';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import TextField from '@material-ui/core/TextField';
import CardHeader from '@mui/material/CardHeader';
import CardActions from '@material-ui/core/CardActions';
import Divider from '@material-ui/core/Divider';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';

import moment from 'moment';
import * as actions from '../store/actions/index';
import * as actionTypes from '../store/actions/actionTypes';
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap'
    },
    header: {
        textAlign: 'center',
        spacing: 10,
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,

    },
    input: {
        borderRadius: 4,
        position: 'relative',
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #ced4da',
        fontSize: 16,
        padding: '10px 5px 10px 5px',
        margin: theme.spacing(1),
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        // Use the system font instead of the default Roboto font.
        fontFamily: [
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
        '&:focus': {
            borderRadius: 4,
            borderColor: '#80bdff',
            boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
        },
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
}));

function DealerPassword(props) {
    const classes = useStyles();
    const [password, setPassword] = useState('');
    const [password2, setPassword2] = useState('');
    //useEffect(()=>{
        //props.onGetClientTransactions(props.token, props.currentClientName);
        //props.onInitializeRetrieveCredits();
    //},[]);

    useEffect(() => {
        if (props.isFailChangePassword){
            console.log('logging isfail', props.isFailChangePassword);
            var errorMessage = '' + props.isFailChangePassword;
            props.onDisplaySnackbar({type: actionTypes.SNACKBAR_TYPE_ERROR, message: errorMessage});
        }
    }, [props.isFailChangePassword]);

    const spinner = (
        <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
        />
    );

    function validateForm() {
        return password === password2 && password.length>3 && password2.length>3;
    }

    function handleSubmit(event) {
        event.preventDefault();
        //console.log("login", client.name);
        //console.log("password", client.password);
        //console.log("macaddress", client.mac);
        //console.log("months", months);
        //console.log("description", client.description);
        //console.log("phone", client.phone);
        const data = {
            name: props.currentDealerName,
            password: password

        };
        console.log('logging data', data);
        //props.onRetrieveCredits(props.token, data);
        props.onChangePassword(props.token, data);

    }

    if(props.isSuccessChangePassword){
        console.log('redirecting because', props.isSuccessChangePassword);
        //props.onGetCredits(props.token);
        //props.onGetClient(props.token, props.currentClientName);
        //props.onGetClientTransactions(props.token, props.currentClientName);
        props.onInitializeChangePassword();
        var successMessage = 'Changed password for ' + props.currentDealerName;
        props.onDisplaySnackbar({type: actionTypes.SNACKBAR_TYPE_SUCCESS, message: successMessage});
    }

    return (
        <Card>
            <CardHeader
                title="Change Password"
                titleTypographyProps={{
                    fontSize: 17,
                    fontWeight: 'bold'
                }}
            />
            <Divider variant="middle" />
            <CardContent>
                <form>
                    <FormGroup row>
                        <FormControl fullWidth>
                            <TextField
                                id="password"
                                value={password}
                                label="Enter password"
                                onChange={e => setPassword(e.target.value)}
                                type="text"
                                fullWidth
                            />
                        </FormControl>
                    </FormGroup>
                    <FormGroup row>
                        <FormControl fullWidth>
                            <TextField
                                id="password2"
                                value={password2}
                                label="Re-enter password"
                                onChange={e => setPassword2(e.target.value)}
                                type="text"
                                fullWidth
                            />
                        </FormControl>
                    </FormGroup>
                </form>
            </CardContent>
            <CardActions>
                <Button
                    block
                    disabled={!validateForm() || props.isLoadingChangePassword}
                    type="submit"
                    variant="contained"
                    color="primary"
                    size="small"
                    onClick={handleSubmit}
                    fullWidth
                >
                    {props.isLoadingChangePassword
                        ? spinner
                        : 'Update'}
                </Button>
            </CardActions>
        </Card>

    );
}

const mapDispatchToProps = dispatch => {
    return {
        onChangePassword: (token, data) => dispatch(actions.changePasswordDealer(token, data)),
        onInitializeChangePassword: () => dispatch(actions.initializeChangePassword()),
        //onGetClient: (token, name) => dispatch(actions.getClient(token, name)),
        //onGetCredits: (token) => dispatch(actions.creditsUser(token)),
        //onGetClientTransactions: (token, login) => dispatch(actions.getTransactionsClient(token, login)),
        onDisplaySnackbar: (message) => dispatch(actions.showSuccessSnackbar(message))

    }
};

const mapStateToProps = state => {
    return {
        token: state.auth.token,
        currentDealerName: state.dealer.name,
        isSuccessChangePassword: state.passwordReducer.name,
        isLoadingChangePassword: state.passwordReducer.loading,
        isFailChangePassword: state.passwordReducer.error
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(DealerPassword);